import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import lodash from 'lodash'
import notification from '@/utils/notification'
import request from '@/utils/request'
import './styles/element-variables.scss'
import '@/styles/index.scss'

window.notification = notification
window.request = request
window._ = lodash

Vue.use(Element, {
  size: 'small'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
